import _ from 'lodash';
import React from 'react';
import moment from 'moment';

import {
    Grid,
    Icon,
    Header
} from 'semantic-ui-react';

import { COULEUR_FOND_VIOLET } from '../../config/colors';


const ReservationListViewPictos = (props) => {
    const {
        dateDebut,
        dateFin,
        statut,
        type,
        maintenance,
    } = props;

    const startHour = moment(dateDebut).format('HH:mm');
    const startDate = moment(dateDebut).format('DD/MM/YYYY');
    const endHour = moment(dateFin).format('HH:mm');
    const endDate = moment(dateFin).format('DD/MM/YYYY');

    const marginPictos = _.isNil(dateDebut)
        ? {}
        : { marginBottom: 18, padding: 0 }

    return (
        <>
            <Grid.Column width={maintenance ? 6 : 8} textAlign='center' style={marginPictos}>
                <div>
                    <Icon name='gavel' style={{ color: '#90c647', fontSize: '1.75rem' }} />
                </div>
                <Header
                    as='h5'
                    style={{
                        paddingTop: 5,
                        margin: 0,
                        color: COULEUR_FOND_VIOLET,
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                    }}
                    title={statut}
                >
                    {!_.isEmpty(statut) ? statut : "-"}
                </Header>
            </Grid.Column>
            <Grid.Column width={maintenance ? 5 : 8} textAlign='center' style={marginPictos}>
                <div>
                    <Icon name='puzzle' style={{ color: '#90c647', fontSize: '1.75rem', transform: 'rotate(180deg)' }} />
                </div>
                <Header
                    as='h5'
                    style={{
                        paddingTop: 5,
                        margin: 0,
                        color: COULEUR_FOND_VIOLET,
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                    }}
                >
                    {_.isEmpty(type) ? '-' : type}
                </Header>
            </Grid.Column>
            {maintenance && (
                <Grid.Column width={5} textAlign='center' style={marginPictos}>
                    <div>
                        <Icon name='warning sign' style={{ color: '#90c647', fontSize: '1.75rem' }} />
                    </div>
                    <Header
                        as='h5'
                        style={{
                            paddingTop: 5,
                            margin: 0,
                            color: COULEUR_FOND_VIOLET
                        }}
                    >
                        En maintenance
                    </Header>
                </Grid.Column>
            )}
        </>
    );
};

export default ReservationListViewPictos;
